import {
  PAGE_HEADER_MAX_HEIGHT,
  PAGE_CONTENT_SPACING,
  TABS_HEIGHT,
  LAYOUT_HEADER_HEIGHT,
  PAGE_WITH_TABS_CONTENT_TOP_SPACING,
} from "@/constants/Layout";

const WINDOW_HEIGHT_LIMIT =
  LAYOUT_HEADER_HEIGHT +
  PAGE_HEADER_MAX_HEIGHT +
  TABS_HEIGHT +
  PAGE_CONTENT_SPACING +
  PAGE_WITH_TABS_CONTENT_TOP_SPACING +
  1;

export const CONTENT_HEIGHT = `calc(100vh - ${WINDOW_HEIGHT_LIMIT}px)`;
